import React, { memo } from 'react';
import { InputUI } from '@fourthwall/components';
import { SEARCH_CHARS_MAX_LIMIT } from '../../../../consts';
import * as S from './styled';
export const CategoryInput = memo(({ value, hasLabel, disabled, inputRef, onChange }) => {
    return (React.createElement(S.Container, null,
        React.createElement(InputUI.Input, { "data-testid": "Input", "$inputSize": "large", type: "text", ref: inputRef, value: value, "$hasLabel": hasLabel, disabled: disabled, maxLength: SEARCH_CHARS_MAX_LIMIT, onChange: onChange })));
});
